<template>
  <div class="homepage__wrapper">
    <awards-top-section>
      <template slot="title">2025 Winners announced</template>
      <awards-top-section-winners-button slot="button" />
    </awards-top-section>

    <awards-about-section />

    <winners-winners-section />

    <winners-highlights-section />

    <homepage-judges-section />
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'
import AwardsTopSectionWinnersButton from 'sections/_shared/AwardsTopSection/AwardsTopSectionWinnersButton'
import AwardsTopSection from 'sections/_shared/AwardsTopSection/index.vue'

export default {
  name: 'WinnersPage',
  mixins: [mixins.initialScroll],
  components: {
    AwardsTopSection,
    AwardsTopSectionWinnersButton,
    AwardsAboutSection: hydrateWhenVisible(() =>
      import('sections/_shared/AwardsAboutSection')
    ),
    WinnersWinnersSection: hydrateWhenVisible(() =>
      import('sections/_winners/WinnersWinnersSection')
    ),
    WinnersHighlightsSection: hydrateWhenVisible(() =>
      import('sections/_winners/WinnersHighlightsSection')
    ),
    HomepageJudgesSection: hydrateWhenVisible(() =>
      import('sections/_homepage/HomepageJudgesSection')
    )
  },
  head() {
    return this.$generateMetaTags()
  }
}
</script>
